import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {
  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

  // Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public courts?;
  public users?;
  public types?;
  isUpdate: boolean = false;
  dbFunction?: string;
  name: string;
  type: string;
  mobile: string;
  country_code: string;
  gender: string;
  dob: Date;
  email: string;
  forceChangePassword: string;
  uploadedImage: File;
  base64Image: string;
  picUrl: string;
  officialPicUrl: string;
  status: string;
  public isLoading = false;
  facilityCountryCode: string;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('resetModal', {static: false}) public resetModal: ModalDirective;
  @ViewChild('resetLevelModal', {static: false}) public resetLevelModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv : ValidationService,
    private storageSrv: StorageService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;

    this.facilityCountryCode = this.storageSrv.getFacilityCountryCode();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.dbFunction = 'updateUsersTable';
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.name = this.mfData['name'];
      this.type = this.mfData['type'];
      this.mobile = this.mfData['mobile'];
      this.country_code = this.mfData['country_code'];
      this.gender = this.mfData['gender'];
      this.dob = this.mfData['dob'] != null ? new Date(this.mfData['dob'].replace(/-/g, "/")) : this.mfData['dob'];
      this.email = this.mfData['email'];
      this.forceChangePassword = this.mfData['forceChangePassword'];
      this.picUrl = this.mfData['picUrl'];
      this.officialPicUrl = this.mfData['officialPicUrl'];
      this.status = this.mfData['status'];
    }
    else
    {
      this.dbFunction = '/addBooking';
      this.name = '';
      this.type = '';
      this.mobile = '';
      this.country_code = '';
      this.gender = '';
      this.dob = new Date();
      this.officialPicUrl = '';
      this.status = '';
    }
    // this.loadUserTypes();
    // this.createForm();
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        await this.loadUserTypes();
        await this.createForm();
      });
    });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      type: [this.type, [Validators.required]],
      name: [this.name, [Validators.required]],
      mobile: [this.mobile, [Validators.required]],
      country_code: [this.country_code, [Validators.required]],
      gender: [this.gender, [Validators.required]],
      dob: [this.dob],
      email: [this.email],
      forceChangePassword: [this.forceChangePassword],
      picUrl: [this.picUrl],
      officialPicUrl: [this.officialPicUrl],
      status: [this.status],
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  uploadFile(event) {
    let files = event.target.files;
    const reader = new FileReader();
    if (files.length > 0) {
      this.uploadedImage = files[0]; // You will see the file
      reader.readAsDataURL(this.uploadedImage);
      reader.onload = (_event) => { 
        this.officialPicUrl = reader.result.toString(); 
    }
    }
  }

  saveUser = () => {

  if (this.uploadedImage != null)
  {
    this.base64Image = this.officialPicUrl;
    this.simpleForm.controls['officialPicUrl'].setValue(this.uploadedImage.name);
  }

  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    const fields = {
      userId: this.mfData['id'],
      name: this.f['name'].value,
      type: this.f['type'].value,
      mobile: this.f['mobile'].value,
      country_code: this.f['country_code'].value,
      gender: this.f['gender'].value,
      dob: this.f['dob'].value,
      email: this.f['email'].value,
      forceChangePassword: this.f['forceChangePassword'].value,
      picUrl: this.f['picUrl'].value,
      officialPicUrl: this.base64Image,
      status: this.f['status'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateUser(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('User Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addUser(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('User Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
  }

  // public submitDB(content: object) {
  //   this.submitted = true;
  //   var fd = new FormData();

  //   // stop here if form is invalid
  //   if (this.simpleForm.invalid) {
  //     var msg = "";
  //     if (this.simpleForm.controls['name'].invalid)
  //     {
  //       msg = "Image not uploaded."
  //     }
  //     else if (this.simpleForm.controls['mobile'].invalid)
  //     {
  //       msg = "Brouchure not uploaded."
  //     }
  //     else if (this.simpleForm.controls['email'].invalid)
  //     {
  //       msg = "Invalid From Date"
  //     }
  //     else if (this.simpleForm.controls['countryCode'].invalid)
  //     {
  //       msg = "Invalid To Date"
  //     }
  //     else if (this.simpleForm.controls['dob'].invalid)
  //     {
  //       msg = "Invalid Date of Birth"
  //     }
  //     else if (this.simpleForm.controls['gender'].invalid)
  //     {
  //       msg = "Invalid Gender"
  //     }
  //     else
  //     {
  //       msg = 'An error has occured, please check missing fields and try again';
  //     }
  //     this.toastComp.doShow("Error", msg);
  //     this.toastComp.doShow("Error", "Check Invalid Fields: " + this.findInvalidControls());
  //     //this.showError("Check Invalid Fields: " + this.findInvalidControls());
  //     //return;
  //   }

  //   // TODO: Use EventEmitter with form value
  //   this.mfData['name'] = this.f['name'].value
  //   this.mfData['mobile'] = this.f['mobile'].value
  //   this.mfData['type'] = this.f['type'].value
  //   this.mfData['country_code'] = this.f['country_code'].value
  //   this.mfData['gender'] = this.f['gender'].value
  //   this.mfData['dob'] = this.f['dob'].value
  //   this.mfData['status'] = this.f['status'].value

  //   let formattedDob = new Date(this.mfData['dob']).toISOString().toString().substr(0, 10);

  //   fd.append('userId',this.mfData['id']);
  //   fd.append('name',this.mfData['name']);
  //   fd.append('mobile',this.mfData['mobile']);
  //   fd.append('type',this.mfData['type']);
  //   fd.append('country_code',this.mfData['country_code']);
  //   fd.append('gender',this.mfData['gender']);
  //   fd.append('dob',formattedDob);
  //   fd.append('status',this.mfData['status']);

  //   let headers = new Headers();
  //   headers.append('Content-Type','application/json');

  //   this.httpService.post(this.dbFunction, fd, '')
  //   .then(
  //     data => {
  //             if (this.isUpdate) {this.showSuccess('User updated');} else {this.showSuccess('User added')}
  //     },
  //     error => {if (this.isUpdate) {this.isError = true;this.toastComp.doShow('Error', 'An error has occured in db, please check missing and try again');this.toolService.showConsoleLog(error);} else {this.isError = true;this.toastComp.doShow('Error', 'An error has occured in db, please check missing and try again');this.toolService.showConsoleLog(error);}},
  //   ).catch();

  // }

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  loadUserTypes = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getUserTypes()
      .then(res => {
        this.types = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    });
  }

  resetPassword = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.resetUserPassword(this.mfData['id'])
      .then(async res => {
        resolve(res);
        this.showSuccess('Password has been reset');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    });
  }

  resetLevel = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.resetUserLevel(this.mfData['id'])
      .then(async res => {
        resolve(res);
        this.showSuccess('Level has been reset');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    });
    }

}
